import styled, {css, keyframes} from "styled-components";
import {Card} from "../../../styles/components";

export const Container = styled.div`
  position: relative;
  z-index: 20;
  padding: 4vh 1%;
  height: 100%;

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 15vh 0 0 0;
  }
`

export const Content = styled.div`
  display: none;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: block;
  }
`

export const MobileContent = styled.div`
  @media only screen and (${({theme}) => theme.media.extraSmall}) {
    display: block;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    display: none;
  }
`

export const TextBlock = styled.div`
  display: none;
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  color: ${({theme}) => theme.colors.primaryFont};
  font-size: calc(0.8rem + 1vw);
  text-align: center;
  transition: 1s all ease;

  @media only screen and (${({theme}) => theme.media.small}/*max-width: 960px*/) {
    font-size: calc(0.8rem + 1vw);
  }

  @media only screen and (${({theme}) => theme.media.medium}/*max-width: 960px*/) {
    font-size: calc(1rem + 1vw);
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: calc(0.3rem + 1vw);
  }
`

const showText = keyframes`
    from {
      opacity: 0;
    } 
    to {
      opacity: 1;
    }
`

export const PictureTitle = styled.div`
  color: ${({theme}) => theme.colors.red};
  text-align: center;
  font-size: calc(0.8rem + 0.5vw);
  text-transform: uppercase;
`

export const PictureBlock = styled.div`
  position: relative;
  &:hover ${TextBlock} {
    display: flex;
    align-items: center;
    animation: ${showText} 500ms linear;
  }

  &:hover ${PictureTitle} {
    opacity: 0;
  }

  &:hover img {
    opacity: 0;
  }
  
  & img {
    width: 56%;
    margin: 0 22% 2vh 22%;
    transition: opacity 1s linear;

    @media only screen and (${({theme}) => theme.media.medium}) {
      width: 70%;
      margin: 0 15%;
    }

    @media only screen and (${({theme}) => theme.media.extraLarge}) {
      width: 56%;
      margin: 0 22% 2vh 22%
    }
  }
`

export const Title = styled.h3`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-transform: uppercase;
  text-align: center;
  color: ${({theme}) => theme.colors.secondaryFont};
  margin-bottom: 20px;

  @media only screen and (${({theme}) => theme.media.small}) {
    font-weight: 600;
    font-size: 40px;
    line-height: 54px;
    margin-bottom: 10vh;
  }
`

export const Block = styled.div`
  display: flex;
  gap: 10px;
  height: 100%;
  padding: 20px 10px 0 0;

  @media only screen and (${({theme}) => theme.media.small}) {
    padding: 20px 10px 0 0;
  }
`

export const Blocks = styled.div`
  height: 100%;
  display: flex;
`

const Line = styled.div`
  height: 160px;
  ${({theme}) => css`border: 1px solid ${theme.colors.cardBorderColor}`};
  background: ${({theme}) => theme.colors.secondaryBackground};

  @media only screen and (${({theme}) => theme.media.small}) {
    height: 230px;
  }
`

export const Line1 = styled(Line)`
  width: 98%;
  border-left: none;
  border-radius: 0 20px 20px 0;
  margin-bottom: 20px;
  
  & ${Blocks} {
    margin-left: 10px;
  }
  
  @media only screen and (${({theme}) => theme.media.small}) {
    width: 85%;
    border-radius: 0 50px 50px 0;
    margin-bottom: 70px;

    & ${Blocks} {
      margin-left: 15%;
    }
  }
`

export const Line2 = styled(Line)`
  width: 98%;
  margin-left: 2%;
  border-right: none;
  border-radius: 20px 0 0 20px;
  margin-bottom: 20px;

  & ${Blocks} {
    margin-left: 0;
  }

  @media only screen and (${({theme}) => theme.media.small}) {
    width: 85%;
    margin-left: 15%;
    margin-bottom: 70px;
    border-radius: 50px 0 0 50px;

    & ${Blocks} {
      margin-left: 5%;
    }
  }
`

export const BlockPicture = styled.img`
  width: auto;
  height: 90%;
`

export const BlockContent = styled.div`
  margin-left: 20px;
`

export const BlockTitle = styled.div`
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.red};
  margin-bottom: 10px;

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 24px;
    line-height: 33px;
    font-weight: 600;
  }
`

export const BlockText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${({theme}) => theme.colors.secondaryFont};

  @media only screen and (${({theme}) => theme.media.small}) {
    font-weight: 400;
    font-size: 22px;
    line-height: 30px;
  }
`